import {ContainerModule} from "@yosmanyga/di";
import {DI as CONTROLLER_DI} from './controller/DI';

const DI = new ContainerModule((...props) => {
    CONTROLLER_DI.registry(...props);
});

export {DI};
